/**
 * GTM/GA4 tracking: view_cart, select_size, select_color, menu_open, menu_click,
 * add_to_wishlist, select_item, banner_click, view_item_list, remove_from_cart, out_of_stock.
 */
(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  function buildViewCartPayload(cart) {
    if (!cart || !cart.items || !cart.items.length) {
      return null;
    }
    const currency = cart.currency || 'USD';
    const value = (cart.total_price || 0) / 100;

    const items = cart.items.map(function (item) {
      const price = (item.final_price ?? item.price ?? 0) / 100;
      return {
        item_id: item.sku || String(item.variant_id || item.id),
        item_name: item.product_title || item.title,
        item_variant: item.variant_title || '',
        price: price,
        quantity: item.quantity
      };
    });

    return {
      currency: currency,
      value: value,
      items: items
    };
  }

  function pushViewCartEvent() {
    const cartUrl = (typeof routes !== 'undefined' && routes.cart_url)
      ? routes.cart_url.replace(/\/?$/, '') + '.js'
      : '/cart.js';
    fetch(cartUrl)
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        const payload = buildViewCartPayload(cart);
        if (payload) {
          window.dataLayer.push({
            event: 'view_cart',
            ecommerce: {
              currency: payload.currency,
              value: payload.value,
              items: payload.items
            }
          });
        }
      })
      .catch(function (err) { console.warn('view_cart GTM: could not fetch cart', err); });
  }

  if (typeof window !== 'undefined') {
    window.pushViewCartEvent = pushViewCartEvent;
    window.buildViewCartPayload = buildViewCartPayload;
  }
})();

(function () {
  'use strict';

  function getSelectedVariantId(scopeEl) {
    var idInput =
      scopeEl.querySelector('form input[name="id"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return idInput ? String(idInput.value || '').trim() : '';
  }

  function getOptionNameFromInput(input) {
    if (input.name && input.name.indexOf('options[') !== -1) {
      var match = input.name.match(/options\[(.*?)\]/);
      if (match && match[1]) return match[1].trim();
    }
    if (input.name) return String(input.name).trim();
    var fieldset = input.closest('fieldset');
    var legend = fieldset ? fieldset.querySelector('legend') : null;
    return legend ? legend.textContent.trim() : '';
  }

  function pushVariantEvent(eventName, params) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: eventName };
    Object.keys(params).forEach(function (k) { payload[k] = params[k]; });
    window.dataLayer.push(payload);
  }

  document.addEventListener('change', function (e) {
    if (!e.isTrusted) return;

    var target = e.target;
    if (!target) return;

    var productInfo = target.closest('product-info') || document;
    var isVariantInput =
      target.matches('variant-radios input[type="radio"]') ||
      target.matches('variant-selects select') ||
      target.matches('[name^="options["]') ||
      target.matches('select[name^="options["]');

    if (!isVariantInput) return;

    var optionName = getOptionNameFromInput(target).toLowerCase();
    var value = (target.value || '').trim();
    if (!value) return;

    var itemId = getSelectedVariantId(productInfo);
    if (!itemId) return;

    if (optionName.indexOf('size') !== -1) {
      pushVariantEvent('select_size', {
        item_id: itemId,
        size: value
      });
      return;
    }

    if (optionName.indexOf('color') !== -1 || optionName.indexOf('colour') !== -1) {
      pushVariantEvent('select_color', {
        item_id: itemId,
        color: value
      });
    }
  });
})();

(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  function getPageType() {
    var body = document.body;
    if (body && body.getAttribute('data-page-type')) {
      return body.getAttribute('data-page-type');
    }
    if (body && body.className) {
      var match = body.className.match(/\b(index|product|collection|page|search|cart|blog|article|list-collections)\b/);
      return match ? match[1] : 'unknown';
    }
    return 'unknown';
  }

  function getMenuLevel(detailsEl) {
    if (!detailsEl || !detailsEl.id) return 1;
    if (detailsEl.id === 'Details-menu-drawer-container') return 1;
    if (detailsEl.id && detailsEl.id.indexOf('Details-menu-drawer-menu-item-') === 0) return 2;
    if (detailsEl.classList && detailsEl.classList.contains('mega-menu')) return 1;
    if (detailsEl.closest && detailsEl.closest('#menu-drawer')) return 2;
    return 1;
  }

  function isMenuDetails(detailsEl) {
    if (!detailsEl || detailsEl.tagName !== 'DETAILS') return false;
    if (detailsEl.classList.contains('mega-menu')) return true;
    if (detailsEl.id === 'Details-menu-drawer-container') return true;
    if (detailsEl.id && detailsEl.id.indexOf('Details-menu-drawer-menu-item-') === 0) return true;
    if (detailsEl.closest('#menu-drawer') && detailsEl.closest('header-drawer')) return true;
    return false;
  }

  document.addEventListener('toggle', function (e) {
    if (!e.target || e.target.tagName !== 'DETAILS') return;
    if (!isMenuDetails(e.target)) return;
    if (!e.target.open && !e.target.hasAttribute('open')) return;

    var menuLevel = getMenuLevel(e.target);
    var pageType = getPageType();

    if (typeof console !== 'undefined' && console.log) {
      console.log('[tracking] menu_open', {
        menu_level: menuLevel,
        page_type: pageType
      });
    }

    window.dataLayer.push({
      event: 'menu_open',
      menu_level: menuLevel,
      page_type: pageType
    });
  }, true);
})();

(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  function getPageType() {
    var body = document.body;
    if (body && body.getAttribute('data-page-type')) {
      return body.getAttribute('data-page-type');
    }
    if (body && body.className) {
      var match = body.className.match(/\b(index|product|collection|page|search|cart|blog|article|list-collections)\b/);
      return match ? match[1] : 'unknown';
    }
    return 'unknown';
  }

  function getMenuLevelFromLink(linkEl) {
    if (!linkEl) return 1;
    if (linkEl.classList.contains('mega-menu__link--level-3')) return 3;
    if (linkEl.classList.contains('mega-menu__link--level-2')) return 2;
    var list = linkEl.closest('ul.mega-menu__list');
    if (list) return 2;
    var level2 = linkEl.closest('ul.level-2');
    if (level2) return 2;
    var level3 = linkEl.closest('ul.level-3');
    if (level3) return 3;
    var level1 = linkEl.closest('ul.level-1');
    if (level1) return 1;
    if (linkEl.closest('.header__inline-menu')) return 1;
    return 1;
  }

  function getMenuName(linkEl) {
    if (!linkEl) return '';
    var text = (linkEl.textContent || '').trim();
    return text.replace(/\s+/g, ' ').substring(0, 200);
  }

  function isMenuLink(linkEl) {
    if (!linkEl || linkEl.tagName !== 'A' || !linkEl.href) return false;
    if (linkEl.closest('.header__inline-menu')) return true;
    if (linkEl.closest('#menu-drawer')) return true;
    return false;
  }

  document.addEventListener('click', function (e) {
    if (typeof console !== 'undefined' && console.log) {
      console.log('[tracking] click handler fired', e.target);
    }

    if (!e.isTrusted) return;
    var target = e.target;
    var link = target.closest('a');
    if (!link) {
      if (typeof console !== 'undefined' && console.log) {
        console.log('[tracking] no anchor found for click');
      }
      return;
    }
    if (!isMenuLink(link)) {
      if (typeof console !== 'undefined' && console.log) {
        console.log('[tracking] anchor is not in menu', link);
      }
      return;
    }

    var menuLevel = getMenuLevelFromLink(link);
    var menuName = getMenuName(link);
    var pageType = getPageType();

    if (typeof console !== 'undefined' && console.log) {
      console.log('[tracking] menu_click', {
        menu_level: menuLevel,
        menu_name: menuName,
        page_type: pageType
      });
    }

    window.dataLayer.push({
      event: 'menu_click',
      menu_level: menuLevel,
      menu_name: menuName,
      page_type: pageType
    });
  }, true);
})();

(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-wishList]');
    if (!btn) return;

    if (btn.dataset.added === "true") return;

    const productId = btn.dataset.proid || '';
    const variantId = btn.dataset.varid || '';

    let productName = '';
    const titleEl = document.querySelector('.product__title h1, .product__title');
    if (titleEl) productName = titleEl.textContent.trim();

    let price = 0;
    const priceEl = document.querySelector('.price-item--regular, .price__regular');
    if (priceEl) {
      price = parseFloat(priceEl.textContent.replace(/[^\d.]/g, '')) || 0;
    }

    console.log('[tracking] add_to_wishlist', { productId, productName, price });

    window.dataLayer.push({
      event: 'add_to_wishlist',
      item_id: variantId || productId,
      item_name: productName,
      price: price
    });
  }, true);
})();

(function () {
  'use strict';

  if (typeof window === 'undefined' || window.__ga4_select_item_bound) return;
  window.__ga4_select_item_bound = true;

  document.addEventListener('click', function (e) {
    var link = e.target.closest('.js-ga4-select-item');
    if (!link) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'select_item',
      ecommerce: {
        item_list_id: link.dataset.itemListId || '',
        item_list_name: link.dataset.itemListName || '',
        items: [{
          item_id: link.dataset.itemId || '',
          item_name: link.dataset.itemName || '',
          item_category: link.dataset.itemCategory || '',
          price: parseFloat(link.dataset.itemPrice || '0'),
          quantity: 1
        }]
      }
    });
  }, true);
})();

(function () {
  'use strict';

  var section = document.querySelector('.slideshow-carousel-section');
  if (!section) return;

  section.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-banner-position]');
    if (!a) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'banner_click',
      banner_name: a.getAttribute('data-banner-name') || '',
      banner_position: a.getAttribute('data-banner-position') || '',
      page_type: a.getAttribute('data-page-type') || '',
      campaign_tag: a.getAttribute('data-campaign-tag') || ''
    });

    if (!a.target || a.target === '_self') {
      e.preventDefault();
      var href = a.href;
      setTimeout(function () {
        window.location.href = href;
      }, 150);
    }
  });
})();

(function () {
  'use strict';

  var payload = window.__viewItemListPayload;
  if (!payload || window.__view_item_list_sent) return;
  window.__view_item_list_sent = true;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'view_item_list',
    ecommerce: {
      item_list_id: payload.item_list_id,
      item_list_name: payload.item_list_name,
      items: payload.items
    }
  });
  try { delete window.__viewItemListPayload; } catch (e) {}
})();

(function () {
  'use strict';

  let previousCart = null;

  async function getCart() {
    try {
      const res = await fetch('/cart.js');
      return await res.json();
    } catch (e) {
      return null;
    }
  }

  function detectRemovedItems(oldCart, newCart) {
    if (!oldCart || !newCart) return;

    const oldItems = {};
    oldCart.items.forEach(i => oldItems[i.key] = i.quantity);

    newCart.items.forEach(i => {
      if (oldItems[i.key]) delete oldItems[i.key];
    });

    Object.keys(oldItems).forEach(key => {
      const removedItem = oldCart.items.find(i => i.key === key);
      if (!removedItem) return;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'remove_from_cart',
        item_id: removedItem.variant_id,
        quantity: removedItem.quantity
      });

      console.log('[tracking] remove_from_cart', removedItem.variant_id, removedItem.quantity);
    });
  }

  const originalFetch = window.fetch;
  window.fetch = async function () {
    const response = await originalFetch.apply(this, arguments);

    try {
      const url = arguments[0].toString();

      if (url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/add')) {
        const newCart = await getCart();
        detectRemovedItems(previousCart, newCart);
        previousCart = newCart;
      }
    } catch (e) {}

    return response;
  };

  getCart().then(cart => previousCart = cart);

})();

(function () {
  "use strict";

  if (!location.pathname.includes("/products/")) return;

  window.__oosFired = window.__oosFired || {};
  const key = location.pathname.split("?")[0];
  if (window.__oosFired[key]) return;

  const productJsonUrl = key.replace(/\/$/, "") + ".js";

  fetch(productJsonUrl)
    .then((r) => r.json())
    .then((product) => {
      if (!product || !product.variants || !product.variants.length) return;

      const outOfStockSizes = [];

      product.variants.forEach((v) => {
        if (v && v.available === false) {
          const size = v.option1 || v.option2 || v.option3;
          if (size) outOfStockSizes.push(String(size));
        }
      });

      if (!outOfStockSizes.length) return;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "out_of_stock",
        item_id: String(product.id || ""),
        item_name: String(product.title || ""),
        product_handle: String(product.handle || ""),
        sizes_out_of_stock: outOfStockSizes.join(", "),
        sizes_out_of_stock_count: outOfStockSizes.length
      });

      console.log("[tracking] out_of_stock fired", {
        item_id: product.id,
        item_name: product.title,
        sizes_out_of_stock: outOfStockSizes
      });

      window.__oosFired[key] = true;
    })
    .catch((e) => console.warn("[tracking] out_of_stock failed", e));
})();
